import React, { useState } from "react";
import "./AccessField.css";
import IOSSpinner from "../../../../HtmlElements/IOSSpinner";
import { CopyLineDuotone } from "../../../../../svgs/CopyLineDuotone";

export default function AccessField({
  field_value,
  onAccessClick,
  showCopyButton = false,
  copyToClipboard
}) {
  const [showLoader, setShowLoader] = useState(false);
  const [unlockedValue, setUnlockedValue] = useState(null);
  const NO_EMAIL = "email_not_unlocked@domain.com";

  // Function to handle copying the email
  const copyToClipboardHandler = () => {
    if (copyToClipboard) {
      copyToClipboard(unlockedValue || field_value); 
    }
  };


  const handleShowField = async (e) => {
    try {
      setShowLoader(true);
      const result = await onAccessClick(e); // assume it returns the real email
      if (result) {
        setUnlockedValue(result); // store updated email
      }
    } catch (err) {
      console.error("Access error", err);
    } finally {
      setShowLoader(false);
    }
  };

  const displayValue = unlockedValue || field_value;




  return (
    <>
      {displayValue && displayValue !== NO_EMAIL && displayValue != null ? (
        <div className="access_mob_subbock mr-0">
          <span className="access_mob_text_show">{displayValue}</span>
          
          
          {showCopyButton && (
            <span
              className="copy-email-icon"
              onClick={copyToClipboardHandler}
              title="Copy Email"
            >
              <CopyLineDuotone width="1rem" height="1rem" />
            </span>
          )}
        </div>
      ) : (
        <div
          className="access_mob_subbock mr-0 cursorP"
          onClick={handleShowField}
        >          
        {showLoader ? <IOSSpinner /> : null}
          <img
            src="/img/access_mail_new.png"
            alt="icon"
            className="access_mob_icon"
          />
          <span className="access_mob_text">Access Email</span>
        </div>
      )}
    </>
  );
}
